import { all } from 'redux-saga/effects';

import sagaAuth from 'store/sagas/auth';
import sagaParticipants from 'store/sagas/participants';
import sagaInterviews from 'store/sagas/interviews';
import sagaJourneys from 'store/sagas/journeys';

export default function* rootSaga() {
  return yield all([sagaAuth(), sagaParticipants(), sagaInterviews(), sagaJourneys()]);
}



// WEBPACK FOOTER //
// ./src/store/sagas/index.js